import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@/i18n';
import { LanguageSelectorModal } from '@/shared/components/LanguageSelectorModal';
import type { SidebarBottomBarProps } from '../types';
import styles from '../Sidebar.module.css';

// Language icon SVG
const LanguageIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.66666 10.6666L14.6667 18.6666" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.33334 18.6666L13.3333 10.6666L16 6.66663" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.66666 6.66663H18.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33334 2.66663H10.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M29.3333 29.3333L22.6667 16L16 29.3333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.6667 24H26.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SidebarBottomBar: React.FC<SidebarBottomBarProps> = ({
  onSignOut,
  isSigningOut = false,
}) => {
  const { t, i18n } = useTranslation();
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);

  const currentLang = SUPPORTED_LANGUAGES.find(l => i18n.language?.startsWith(l.code));

  return (
    <div className={styles.bottomBar}>
      <button
        type="button"
        className={styles.signOutButton}
        onClick={onSignOut}
        disabled={isSigningOut}
      >
        {isSigningOut ? t('profile.signingOut') : t('profile.signOut')}
      </button>

      <button
        type="button"
        className={styles.languageSelectWrapper}
        onClick={() => setIsLanguageModalOpen(true)}
        aria-label={t('sidebar.selectLanguage', 'Select language')}
      >
        <LanguageIcon size={20} />
        <span className={styles.languageLabel}>
          {currentLang?.code.toUpperCase() || 'EN'} — {currentLang?.nativeName || 'English'}
        </span>
      </button>

      <LanguageSelectorModal isOpen={isLanguageModalOpen} onClose={() => setIsLanguageModalOpen(false)} />
    </div>
  );
};
